import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/feven_horizontal_white.svg'
import _imports_1 from '@/assets/img/navbar/dashboard_icon.svg'
import _imports_2 from '@/assets/img/navbar/dashboard_icon_on.svg'
import _imports_3 from '@/assets/img/arrow_right_brand.svg'
import _imports_4 from '@/assets/img/arrow_right_blue.svg'
import _imports_5 from '@/assets/img/navbar/affinity_off.svg'
import _imports_6 from '@/assets/img/navbar/affinity_on.svg'
import _imports_7 from '@/assets/img/navbar/chat_off.svg'
import _imports_8 from '@/assets/img/navbar/chat_on.svg'
import _imports_9 from '@/assets/img/navbar/user_icon.svg'
import _imports_10 from '@/assets/img/navbar/user_icon_on.svg'
import _imports_11 from '@/assets/img/navbar/questions_icon.svg'
import _imports_12 from '@/assets/img/navbar/questions_icon_on.svg'
import _imports_13 from '@/assets/img/navbar/experiences_icon.svg'
import _imports_14 from '@/assets/img/navbar/expericens_icon_on.svg'
import _imports_15 from '@/assets/img/navbar/dictionary_icon.svg'
import _imports_16 from '@/assets/img/navbar/dictionary_icon_on.svg'
import _imports_17 from '@/assets/img/navbar/configuration_icon.svg'
import _imports_18 from '@/assets/img/navbar/configuration_icon_on.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c037ab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_2
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon me-0",
  src: _imports_3
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_5
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_6
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_7
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_8
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_9
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_10
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_9
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_10
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_11
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_12
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_13
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_14
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_13
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_14
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_43 = { class: "d-flex align-items-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_11
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_12
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_9
}, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_10
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_15
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_16
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_58 = { class: "d-flex align-items-center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_17
}, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_18
}, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_17
}, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on",
  src: _imports_18
}, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon_on me-0",
  src: _imports_4
}, null, -1))
const _hoisted_68 = { class: "logout_div" }
const _hoisted_69 = { class: "fev_text6 fw_600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sideBar bg_blue", { menuOpened: _ctx.isMenuOpen }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo_image pointer",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/dashboard')))
      })
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/dashboard",
        alt: "Dashboard"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Dashboard",
              text: "Dashboard"
            })
          ]),
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/affinity-list",
        alt: "affinity-list"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Affinity",
              text: "Affinity"
            })
          ]),
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/chat-list",
        alt: "chat-list"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Chats",
              text: "Chats"
            })
          ]),
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/users",
        alt: "Users"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Users",
              text: "Users"
            })
          ]),
          _hoisted_21,
          _hoisted_22
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/fakeprofile",
        alt: "Fake Profile"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_FakeProfile",
              text: "Fake Profile"
            })
          ]),
          _hoisted_26,
          _hoisted_27
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/reports",
        alt: "reports"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _hoisted_30,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_UsersReports",
              text: "Users Reports"
            })
          ]),
          _hoisted_31,
          _hoisted_32
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/experience-requests",
        alt: "Experience Requests"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_ExperienceRequests",
              text: "Exp. Requests"
            })
          ]),
          _hoisted_36,
          _hoisted_37
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/experience-list",
        alt: "Experiences"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _hoisted_40,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Experiences",
              text: "Experiences"
            })
          ]),
          _hoisted_41,
          _hoisted_42
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/expreports",
        alt: "Experience Reports"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _hoisted_45,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_ExperienceReports",
              text: "Exp. Reports"
            })
          ]),
          _hoisted_46,
          _hoisted_47
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/influencer-list",
        alt: "Influencer"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _hoisted_50,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Influencer",
              text: "Influencer"
            })
          ]),
          _hoisted_51,
          _hoisted_52
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/dictionary",
        alt: "Dictionary"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _hoisted_55,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Dictionary",
              text: "Dictionary"
            })
          ]),
          _hoisted_56,
          _hoisted_57
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/configuration",
        alt: "Configuration"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _hoisted_60,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Configuration",
              text: "Configuration"
            })
          ]),
          _hoisted_61,
          _hoisted_62
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/app-modals",
        alt: "AppModals"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _hoisted_65,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_AppModals",
              text: "App Modals"
            })
          ]),
          _hoisted_66,
          _hoisted_67
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$store.state.loggedUser.username), 1),
      _createElementVNode("a", {
        class: "logout_clickable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
      }, [
        _createVNode(_component_localized_text, {
          class: "fev_text7 mt-2 fw_600",
          localizedKey: "backoffice_Logout",
          text: "Logout"
        })
      ])
    ])
  ], 2))
}